import { IUser } from '../../../types/users';
import { ILayersData } from '../../../types/layers';

export enum ActionTypes {
  getLayersRequest = 'GET_LAYERS_REQUEST',
  getLayersSuccess = 'GET_LAYERS_SUCCESS',
  getLayersFailure = 'GET_LAYERS_FAILURE',
}

export interface ILayersState {
  regions: ILayersData[];
  roads: ILayersData[];
}

export interface ILayerInput {
  user: IUser;
  jwt: string;
}

export interface IGetLayersRequestReturn {
  type: string;
  payload: {
    input: ILayerInput;
  };
}

export interface IGetLayersSuccessReturn {
  type: string;
  payload: {
    input: ILayersState;
  };
}
